import { useTranslation } from "react-i18next";
import { Button } from "components/button";

interface ProductNavigationBarSalesDataActionsProps {
  onExplainerOpen: () => void;
}

export const ProductNavigationBarSalesDataActions = ({
  onExplainerOpen,
}: ProductNavigationBarSalesDataActionsProps) => {
  const { t } = useTranslation(["productDetails"]);

  return (
    <Button
      icon="circle-question-mark"
      variant="tertiary"
      size="small"
      onClick={onExplainerOpen}
      analyticsId="button_sales_data_explainer"
      className="size-8 flex items-center justify-center"
      testId="sales-data-explainer-trigger"
      aria-label={t("productDetails:salesData.explainer.openAria")}
    />
  );
};
